import ComplaintDetailContent from './ComplaintDetailContent.jsx';

export {ComplaintDetailContent}



// WEBPACK FOOTER //
// ./components/users/sub-view/complaint-detail-content/index.js